import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Creative Burnout',
  description: "You arrive at the studio exhausted after spending hours scrolling through social media looking for new combinations that you don't know how to connect into a real class structure."
}, {
  emoji: '🎵',
  title: 'Lack of Flow',
  description: "Your classes lose their energy. You improvise transitions and fear your students aren't progressing logically from week to week — and you can feel it in the room."
}, {
  emoji: '📱',
  title: 'Information Overload',
  description: "You search online and find contradictory advice. You don't know what structure is most effective for a 60-minute session that keeps students engaged from warm-up to cool-down."
}, {
  emoji: '😩',
  title: 'Massive Mental Load',
  description: 'Managing students, music, choreography and weekly planning stops you from enjoying your true passion — the dance itself.'
}];
export function PainSection() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-cream" data-id="element-108">
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-taupe mb-1 uppercase leading-tight" data-id="element-109">
        DO YOU RECALL THIS?
      </h2>

      <p className="text-sm sm:text-base text-brand-taupe font-semibold text-center mb-4 leading-tight" data-id="element-110">
        You love teaching, but does preparation steal all your free time?
        <br data-id="element-111" />
        <span className="text-brand-rose" data-id="element-112">
          If you are a Dance instructor, you probably know one of these
          situations:
        </span>
      </p>

      <div className="flex flex-col gap-2" data-id="element-113">
        {pains.map((pain, i) => <div key={i} className="bg-white p-3 rounded-md border-l-4 border-brand-rose shadow-sm flex gap-3 items-start" data-id="element-114">
            <div className="text-2xl leading-none shrink-0" data-id="element-115">{pain.emoji}</div>
            <div data-id="element-116">
              <h3 className="text-sm font-bold text-brand-taupe mb-0.5 uppercase tracking-tight" data-id="element-117">
                {pain.title}
              </h3>
              <p className="text-brand-taupe/80 text-xs sm:text-sm font-medium leading-tight" data-id="element-118">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}